export default __webpack_public_path__ + "static/media/971.8d186d69.gif";